import { Card } from '@chakra-ui/react'

export default (props) => {
  return (
    <Card.Root {...props}>
      <Card.Body {...props}>
        {props.children}
      </Card.Body>
    </Card.Root>
  )
}
